import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';

import styles from './RapportGenere.module.scss';

import Bouton from '../../UI/Bouton/Bouton';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import ConteneurInformation from '../../ConteneurInformation/ConteneurInformation';
import * as indexConteneurInfo from '../../../ressources/glossaires/glossaire_conteneur_info';
import FormulaireRapportGenere from './ProfilRapportGenere/FormulaireRapportGenere/FormulaireRapportGenere';
import ProfilRapportGenere from './ProfilRapportGenere/ProfilRapportGenere.js';
import * as actions from '../../../services/actions';
import TableauRapportGenere from './TableauRapportGenere/TableauRapportGenere';

class RapportGenere extends Component {
  state = {
    parametresSelectione: {},
    montrerInfo: false,
    indexConteneurInfo: null,
    montrerInfoFull: false,
  };

  /**
   * Handles selection of a row from the report table
   * @param {Object} info - The selected row data
   */
  ligneSelectione = (info) => {
    this.setState({
      parametresSelectione: info,
      indexConteneurInfo: indexConteneurInfo.profil,
      montrerInfo: true,
    });
  };

  /**
   * Toggles the info container visibility
   * When closing, also resets the fullscreen mode
   */
  commutateurInfoCreer = () => {
    this.setState((prevState) => ({
      montrerInfo: !prevState.montrerInfo,
      // When closing the panel, also disable fullscreen
      montrerInfoFull: prevState.montrerInfo
        ? false
        : prevState.montrerInfoFull,
    }));
  };

  /**
   * Toggles the fullscreen mode for the info container
   */
  commutateurInfoFull = () => {
    this.setState((prevState) => ({
      montrerInfoFull: !prevState.montrerInfoFull,
    }));
  };

  /**
   * Handles cancellation of form operations
   * Closes the info container and resets its type
   */
  commutateurAnnuler = () => {
    this.setState({
      montrerInfo: false,
      indexConteneurInfo: null,
    });
  };

  //fonction pour ouverture du conteneur information avec le formulaire de création
  creerVue = () => {
    this.setState({
      ...this.state,
      montrerInfo: true,
      indexConteneurInfo: indexConteneurInfo.ajouterForm,
    });
  };

  render() {
    //initialisation des varable de style
    let styleConteneurCentralGauche = [styles.ConteneurCentralGauche];
    let styleConteneurCentralDroite = [styles.ConteneurCentralDroite];
    let commutateurClasses = [styles.CommutateurInfo];

    if (this.state.montrerInfo) {
      //style pour un conteneur info ouvert
      styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteOuvert);
      // styleConteneurCentralDroite.push(S.ConteneurCentralGaucheOuvert);
    } else {
      //style pour un conteneur info fermé
      styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteFermer);
      styleConteneurCentralGauche.push(styles.ConteneurCentraGaucheFermer);
    }

    if (this.state.montrerInfo && this.state.montrerInfoFull) {
      //conteneur info ouvert & plein écran
      //on met la largeur à 100% du conteneur info
      styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteFull);
      //on réduit à zéro la largeur du conteneur central
      styleConteneurCentralGauche.push(styles.ConteneurCentraGaucheVoid);
    } else if (this.state.montrerInfo && !this.state.montrerInfoFull) {
      //conteneur info ouvert & !plein écran
      styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteOuvert);
    } else {
      //conteneur info fermé
      styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteFermer);
      styleConteneurCentralGauche.push(styles.ConteneurCentraGaucheFermer);
    }

    return (
      <>
        <div className={styleConteneurCentralGauche.join(' ')}>
          <TableauRapportGenere
            projetSelectione={this.ligneSelectione}
            creer={this.creerVue}
          >
            {/*<AccesRestreins*/}
            {/*    listNumPrivilege={[privilege.creer_des_Generes, privilege.modifier_des_Generes, privilege.supprimer_des_Generes]}>*/}
            {/*    {GenereVar}*/}
            {/*</AccesRestreins>*/}
            {/*{GroupeEmailVar}*/}
          </TableauRapportGenere>
        </div>
        <div className={styleConteneurCentralDroite.join(' ')}>
          {/* bouton plein ferme conteneur  info */}
          <Bouton
            ajoutClass={[commutateurClasses, styles.expandTO].join(' ')}
            cliquer={this.commutateurInfoCreer}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromLeft size={15} />
          </Bouton>
          {/* bouton plein écran */}
          <Bouton
            ajoutClass={styles.expand}
            cliquer={this.commutateurInfoFull}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromRight size={15} />
          </Bouton>
          <ConteneurInformation
            // information du type de conteneur information à afficher
            selectionInfo={this.state.indexConteneurInfo}
            // formulaire de création
            ajouterForm={
              <FormulaireRapportGenere
                ajouterAlerte={this.props.ajouterAlerte}
                annuler={this.commutateurAnnuler}
              />
            }
            // formulaire de profil vue
            profil={
              <ProfilRapportGenere
                infoRapportGenere={this.state.parametresSelectione}
                reqPublierRapportGenere={this.props.reqPublierRapportGenere}
                reqModifier={this.props.reqModifier}
                reqSupprimer={this.props.reqSupprimer}
              />
            }
          />
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    ajouterAlerte: (typeAlerte, titre, corps) =>
      dispatch(actions.ajouterAlerte(typeAlerte, titre, corps)),
    reqSupprimer: (idRapportGenere) =>
      dispatch(actions.reqSupprimerRapportGenere(idRapportGenere)),
    reqPublierRapportGenere: (generate_report_id) =>
      dispatch(actions.reqPublierRapportGenere(generate_report_id)),
  };
};

export default connect(null, mapDispatchToProps)(RapportGenere);
